import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./Login.css";
import {
  Alert,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { userLogin } from "../../redux/actions/user-action";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiPost } from "../../utils/apiRequests";
import ApiEndpoints from "../../utils/ApiEndpoints";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import MarkEmailUnreadRoundedIcon from "@mui/icons-material/MarkEmailUnreadRounded";

const LOGO = require("../../assets/images/logo.png");
const LOGIN_BG = require("../../assets/images/login-bg-01.png");

const myStyles = makeStyles({
  outlineInputBorder: {
    "& * > fieldset > legend": {
      display: "none",
    },
    // height: "40px",
    // "& * > input": {
    //   padding: "5px !important",
    // },
    // "& > div": {
    //   padding: "10px !important",
    // },
    // padding: "5px !important"
  },
  signinbtn: {
    backgroundColor: "rgb(6 98 59) !important",
    border: 0,
    color: "white !important",
    height: 48,
    padding: "0 30px",
  },
  logoImage: {
    width: "70px !important",
    // height: "10px !important",
    marginBottom: "20px",
  },
  loginBtn: {
    backgroundColor: "#06623B !important",
    marginTop: "15px !important",
    // "&:hover": {
    //   backgroundColor: "#06623B",
    // },
  },
});

const ForgetPassword = () => {
  const theme = createTheme();
  const classes = myStyles();

  const [email, setEmail] = useState("");

  const [checkEmail, setCheckEmail] = useState(false);

  const [changeToNext, setChangeToNext] = useState(false);
  const [emailMessage, setEmailMessage] = useState("");

  const handleChangeEmail = (e) => {
    const { value } = e.target;
    setEmail(value);
  };

  const handleSubmit = () => {};

  const handleRedirect = () => {
    window.location.href = "/login";
  };

  const emailValidation = (mail) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }
    alert("You have entered an invalid email address!");
    return false;
  };

  const onSubmitResetPassword = () => {
    const data = emailValidation(email);
   // console.log("data", data);
    if (data == true) {
      apiPost(
        ApiEndpoints.resetPassword,
        { email },
        (res) => {
         // console.log("res", res);
          setChangeToNext(true);
          setEmailMessage(res?.message);
          if (res?.message == "A Player with this email does not exist") {
            setCheckEmail(true);
          }
        },
        (err) => {
         // console.log("err", err);
        }
      );
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />

        {changeToNext ? (
          <Grid item container xs={6} sm={6} md={6}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              alignItems="center"
              justifyContent="center"
              display="flex"
            >
              <Stack
                justifyContent="center"
                // display="flex"
                alignItems="stretch"
                height="100%"
                sx={{ margin: "auto" }}
                spacing={2}
              >
                <Box>
                  <Box>
                    <img className={classes.logoImage} src={LOGO} />
                  </Box>
                  {checkEmail == true ? (
                    ""
                  ) : (
                    <>
                      {" "}
                      <Typography variant="h5" fontWeight={600} gutterBottom>
                        Check Your Email
                      </Typography>
                    </>
                  )}

                  <Box mt={2}>
                    {checkEmail == true ? (
                      ""
                    ) : (
                      <MarkEmailUnreadRoundedIcon
                        sx={{ mb: 1.5, color: "#06623B !important" }}
                        fontSize="large"
                      />
                    )}
                    <Typography sx={{ width: "400px" }}>
                      {emailMessage}
                    </Typography>

                    <Button
                      className={classes.loginBtn}
                      variant="contained"
                      onClick={handleRedirect}
                    >
                      Back To Login
                    </Button>
                  </Box>

                  {/* {inputError && (
                 <Alert variant="filled" severity="error">
                   {passwordErrorMessage}
                   {emailErrorMessage}
                 </Alert>
               )} */}
                </Box>
              </Stack>
              {/* </Grid>
             </Grid> */}
            </Grid>
          </Grid>
        ) : (
          <Grid item container xs={6} sm={6} md={6}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              alignItems="center"
              justifyContent="center"
              display="flex"
            >
              <Stack
                justifyContent="center"
                // display="flex"
                alignItems="stretch"
                height="100%"
                sx={{ margin: "auto" }}
                spacing={2}
              >
                <Box>
                  <Box>
                    <img className={classes.logoImage} src={LOGO} />
                  </Box>
                  <Typography variant="h5" fontWeight={600} gutterBottom>
                    Forgot Password
                  </Typography>
                  <Box mt={2}>
                    <Typography
                      variant="body2"
                      // fontSize={20}
                      // fontWeight={400}
                      // color="#1E293B"
                    >
                      Email
                    </Typography>
                    <TextField
                      //   error={inputErrors.emailError ? true : false}
                      //   helperText={
                      //     inputErrors.emailError ? inputErrors.emailErrMsg : ""
                      //   }
                      margin="normal"
                      className={classes.outlineInputBorder}
                      required
                      fullWidth
                      id="email"
                      autoComplete="email"
                      value={email}
                      onChange={handleChangeEmail}
                      autoFocus
                      // sx={{ mb: 2 }}
                      //   value={values.email}
                      //   onChange={handleChange("email")}
                    />

                    <LoadingButton
                      sx={{ mt: 5, borderRadius: 5 }}
                      fullWidth
                      //   loading={inputErrors.loginSpin ? true : false}
                      variant="contained"
                      onClick={onSubmitResetPassword}
                      className={classes.loginBtn}
                      // sx={{
                      //   backgroundColor: "#06623B"
                      // }}
                    >
                      Send Code
                    </LoadingButton>
                  </Box>

                  {/* {inputError && (
                 <Alert variant="filled" severity="error">
                   {passwordErrorMessage}
                   {emailErrorMessage}
                 </Alert>
               )} */}
                </Box>
              </Stack>
              {/* </Grid>
             </Grid> */}
            </Grid>
          </Grid>
        )}

        {/* Right Column */}
        <Grid
          item
          xs={false}
          sm={6}
          md={6}
          direction="column"
          // alignItems="center"
          justifyContent="center"
          display="flex"
          sx={{
            backgroundImage: `url(${LOGIN_BG})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <Box sx={{ margin: "auto" }}>
            <Box>
              <Typography
                variant="caption"
                fontSize="35px"
                // gutterBottom
                fontWeight={50}
                color={"#FFF"}
              >
                Welcome to
              </Typography>
            </Box>
            <Box>
              <Typography
                variant="h3"
                component="h2"
                gutterBottom
                color={"#FFF"}
                fontWeight={700}
              >
                Legends Golf Tour
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

export default ForgetPassword;
